export class SIQInAppNotificationTheme {
  titleColor = "null";
  subtitleColor = "null";
  backgroundColor = "null";
  imageBackgroundColor = "null";
  cornerRadius = null; // Int
  imageCornerRadius = null; // Int
}
//# sourceMappingURL=SIQInAppNotificationTheme.js.map